// extracted by mini-css-extract-plugin
export default {"root":"ChangePasswordForm_root__+ldqs","form":"ChangePasswordForm_form__0w6sB","after":"ChangePasswordForm_after__JwOlR"};